import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from './ApplicationContext';
import {getDataWithFetch, postDataWithFetch} from './Utils';
import "../assets/css/modal.css";

const SiteClosedModal = ({ setOpenModal }) => {
	const data = useContext(ApplicationContext);
	const [statusText, setStatusText] = useState("");
    const [siteClosedFlag, setShowSiteClosedFlag] = useState(data?.siteClosedFlag ? true : false);
    const [siteClosedMessage, setSiteClosedMessage] = useState(data?.siteClosedMessage ? data?.siteClosedMessage : "");
    const [siteClosedVideoUrls, setSiteClosedVideoUrls] = useState(["", "", "", "", ""]);
	const [selectedTimeZone, setSelectedTimeZone] = useState(null);
	const [currentTime, setCurrentTime] = useState("");

    useEffect(() => {
		if (data.BASE_URL) {
			(async() => {
                const url = `${data.BASE_URL}index.php/misc/get_site_closed_flag`;

				// console.log('DEBUG:  Admin - ', url);
				const json = await getDataWithFetch(url);
                setShowSiteClosedFlag(json?.SITE_CLOSED);
                setSiteClosedMessage(json?.SITE_CLOSED_MESSAGE);
                const videoUrls = json?.SITE_CLOSED_VIDEO_URLS || [];
                setSiteClosedVideoUrls([
                    videoUrls[0] || "",
                    videoUrls[1] || "",
                    videoUrls[2] || "",
                    videoUrls[3] || "",
                    videoUrls[4] || ""
                ]);

				// Load timezone data
				const tzUrl = `${data.BASE_URL}index.php/misc/get_time_zones`;
				const timeZones = await getDataWithFetch(tzUrl);
				if (timeZones && Array.isArray(timeZones)) {
					const selected = timeZones.find(tz => tz.showOnTempPage);
					setSelectedTimeZone(selected || null);
				}

				// console.log('DEBUG:  output of update_reset_top_stories - ', typeof json, json);
			})();
		}
    }, [data.BASE_URL]);

	// Update time every second
	useEffect(() => {
		const updateTime = () => {
			if (selectedTimeZone && selectedTimeZone.timeZone) {
				const now = new Date();
				const options = {
					timeZone: selectedTimeZone.timeZone,
					hour: '2-digit',
					minute: '2-digit',
					second: '2-digit',
					hour12: true
				};
				const timeString = now.toLocaleTimeString('en-US', options);
				setCurrentTime(timeString);
			}
		};

		updateTime();
		const interval = setInterval(updateTime, 1000);
		return () => clearInterval(interval);
	}, [selectedTimeZone]);

	// Only update when Save is clicked
	const handleSave = async () => {
		if (data.BASE_URL) {
			const url = `${data.BASE_URL}index.php/misc/update_site_closed_flag`;
			const payload = {
                SITE_CLOSED: siteClosedFlag, 
                SITE_CLOSED_MESSAGE: siteClosedMessage,
                SITE_CLOSED_VIDEO_URLS: siteClosedVideoUrls.filter(url => url.trim() !== "")
            };
			console.log('DEBUG: Saving video URLs:', payload);
			const json = await postDataWithFetch(url, payload);
			console.log('DEBUG: Server response:', json);

            setStatusText(`Site Closed Flag set to ${JSON.stringify(json?.data?.SITE_CLOSED)}`);
		}
	};

	return (
		<div className="modalBackground">
			<div className="modalContainer">
				{selectedTimeZone && (
					<div style={{
						position: 'absolute',
						top: '20px',
						left: '20px',
						color: '#0077FF',
						fontWeight: 'bold',
						fontSize: '16px',
						zIndex: 1000
					}}>
						<div>{selectedTimeZone.label}</div>
						<div style={{ fontSize: '14px', marginTop: '4px' }}>{currentTime}</div>
					</div>
				)}
				<div className="titleCloseBtn">
					<button onClick={() => {setOpenModal(false)}}>X</button>
				</div>
				{/* We add textAlign in here becasue model.css is reused for the credit card dialog so customize this one here. */}
					<div className="title" style={{textAlign:"center"}}>
                    <div className="button-container">
						<div className="footer">
							<button onClick={() => {
								data.siteClosedFlag = false;
								window.open(window.location.origin + window.location.pathname, "_blank");
								setOpenModal(false);
							}} id="saveBtn">Go to Terminal</button>
						</div>
						<input type="text" value={siteClosedMessage} onChange={(e) => {
                            setSiteClosedMessage(e.target.value);
                        }} placeholder="Site Closed Message" />

						{[0, 1, 2, 3, 4].map(index => (
							<input 
								key={index}
								type="text" 
								value={siteClosedVideoUrls[index]} 
								onChange={(e) => {
									const newUrls = [...siteClosedVideoUrls];
									newUrls[index] = e.target.value;
									setSiteClosedVideoUrls(newUrls);
								}} 
								placeholder={`YouTube Video URL ${index + 1} (e.g. https://www.youtube.com/watch?v=VIDEO_ID)`} 
							/>
						))}

						<p className="paragraph-status-text">In order to quickly enable/disable the site and put up a message.</p>
                        <label className="checkbox-container dialog-checkbox">
                            <input 
                                className="sr-only" 
                                type="checkbox" 
                                checked={siteClosedFlag} 
                                onChange={() => {
                                    setShowSiteClosedFlag(!siteClosedFlag ? true : false);
                                }}
                            />
                            <div className="slider"></div>
                            <span className="label">ENABLED</span>
                        </label>
                    </div>

				</div>

				<div className="status-text" style={{display: statusText?.length ? 'block' : 'none'}}>
					<p className="paragraph-status-text">{statusText}</p>
				</div>

				<div className="footer">
					<button onClick={() => {
						handleSave();
						setTimeout(() => {
							// Close the dialog after somet unes.  We just want to show the user that it was saved.
							// It saves too quickly to see the status change.
							setOpenModal(false);
						}, 1500);
						// Close the modal after saving
					}} id="saveBtn">Save</button>
					<button onClick={() => {setOpenModal(false)}} id="cancelBtn">Close</button>
				</div>
			</div>
		</div>
	);
};

export default SiteClosedModal;
